export const GET_CARDS = "GET_CARDS";
export const GET_TABLE = "GET_TABLE";
export const GET_PAYMENTMETHON_LIST = "GET_PAYMENTMETHON_LIST";
export const GET_STATE_LOADING = "GET_STATE_LOADING";
